import React, { useEffect, useMemo, useState } from 'react';
import { cloneDeep, isEqual } from 'lodash';
import { withRouter, browserHistory } from 'react-router';
import {
  useDispatch,
  useSelector,
} from '../../components/common/react-redux-hooks';
import {
  setSupportNav,
  setAddNewFlag,
  setAddNewEntitlement,
  setIsSummary,
  setEditEntitlement,
  setUnsavedChangeFlag,
  setEditedAccountData,
  dataCheck,
  resetCreatAccountForm,
  hasEntUnsavedChanges,
  resetContractId,
  updateAccountData,
  getDetailByContractId,
} from '../../actions/contractAdminActions';
import LeftNav from './LeftNav';
import ContractAdminView from './ContractAdminView';
import CAAddNew from './CAAddNew';
import Entitlement from '../../components/contractAdmin/Entitlement';
import CASummary from './CASummary';
import {
  resetForm,
  isDisable,
  isAccountDetailChangedFun,
} from '../../util/ContractAdminUtils';
import RouterLeaveModal from './RouterLeaveModal';
import { toastError } from '../../util/toastUtils';
import { CA_NAV_DISABLING_MSG } from '../../constants';
import { SET_SELECTED_CONTRACT_ID } from '../../actions/actionTypes';
import { memo } from 'react';

let navConfirmed = false;
const ContractAdmin = props => {
  const ref = React.useRef();
  const dispatch = useDispatch();
  const [routerLeaveModal, setRouterLeaveModal] = useState(false);
  const [nextLocation, setNextLocation] = useState('');

  const {
    navItems,
    addNewFlag,
    addNewEntitlement,
    isSummary,
    editEntitlement,
    editedAccountData,
    addAccount,
    loginResponse,
    // editEntitlement,
    isTPPAccountSelected,
    selectedEntitlementId,
    selectedContractId,
    accountId,
    propCodes,
  } = useSelector(state => ({
    navItems: state.contractAdmin.navItems,
    addNewFlag: state.contractAdmin.addNewFlag,
    addNewEntitlement: state.contractAdmin.addNewEntitlement,
    isSummary: state.contractAdmin.isSummary,
    editEntitlement: state.contractAdmin.editEntitlement,
    addNewFormUnsavedChangeFlag:
      state.contractAdmin.addNewFormUnsavedChangeFlag,
    editedAccountData: state.contractAdmin.editedAccountData,
    addAccount: state.contractAdmin.addAccount,
    loginResponse: state.login.loginResponse,
    //editEntitlement: state.contractAdmin.editEntitlement,
    isTPPAccountSelected: state.contractAdmin.addAccount.accountType === 'TPP',
    selectedEntitlementId: state.contractAdmin.selectedEntitlementId,
    selectedContractId: state.contractAdmin.selectedContractId,
    accountId: state.contractAdmin.addAccount.accountId,
    //contracts: state.contractAdmin.addAccount.contracts,

    propCodes: state.contractAdmin.propCodes,
  }));

  const updateSupportNav = (parent, child) => {
    const hasEntUnsavedChangesData = dispatch(hasEntUnsavedChanges(ref));
    const isDisableFlag = isDisable(
      parent,
      child,
      addAccount,
      addNewFlag,
      addNewEntitlement
    );

    if (isDisableFlag) {
      toastError(CA_NAV_DISABLING_MSG);
    } else {
      const oldData = cloneDeep(addAccount);
      let isAccountDetailChanged = false;
      if (addNewFlag) {
        isAccountDetailChanged = isAccountDetailChangedFun(ref, oldData);
      }

      if (isAccountDetailChanged || hasEntUnsavedChangesData) {
        dispatch(setUnsavedChangeFlag(true));
      } else {
        if (child === 'Search') {
          dispatch(setAddNewFlag(false));
          dispatch(setIsSummary(false));
          dispatch(setEditEntitlement(false));
          dispatch(setAddNewEntitlement(false));
          dispatch(resetContractId(''));
          dispatch(resetCreatAccountForm());
          dispatch(updateAccountData(resetForm()));
          dispatch(setEditedAccountData(resetForm()));
          dispatch({
            type: SET_SELECTED_CONTRACT_ID,
            payload: '',
          });
        }
        if (child === 'Details') {
          dispatch(getDetailByContractId(selectedContractId));
          dispatch(setAddNewFlag(true));
          dispatch(setIsSummary(false));
          dispatch(setEditEntitlement(false));
          dispatch(setAddNewEntitlement(false));
        } else if (child === 'Entitlement Creation') {
          dispatch(setAddNewEntitlement(true));
          dispatch(setAddNewFlag(false));
          dispatch(setIsSummary(false));
          dispatch(setEditEntitlement(false));
        } else if (child === 'Summary') {
          dispatch(setAddNewFlag(false));
          dispatch(setIsSummary(true));
          dispatch(setEditEntitlement(false));
          dispatch(setAddNewEntitlement(false));
        }
        dispatch(setSupportNav(parent, child));
      }
    }
  };

  const defaultSupportNav = () => {
    dispatch(setSupportNav('Contract', 'Search'));
    dispatch(resetCreatAccountForm());
    dispatch(updateAccountData(resetForm()));
    dispatch(setEditedAccountData(resetForm()));
    dispatch(setEditEntitlement(false));
    dispatch(setAddNewFlag(false));
    dispatch(setIsSummary(false));
    dispatch(setAddNewEntitlement(false));
    dispatch(resetContractId(''));
    dispatch({
      type: SET_SELECTED_CONTRACT_ID,
      payload: '',
    });
  };

  useEffect(() => {
    defaultSupportNav();
    return () => {
      defaultSupportNav();
    };
  }, []);

  const beforeunload = e => {
    const isIdle = sessionStorage.getItem('isIdle');
    const unSavedChange = dispatch(dataCheck());
    const hasEntUnsavedChangesData = dispatch(hasEntUnsavedChanges(ref));
    if ((unSavedChange || hasEntUnsavedChangesData) && !JSON.parse(isIdle)) {
      e.preventDefault();
      e.returnValue = true;
    }
  };

  useEffect(() => {
    window.addEventListener('beforeunload', beforeunload);
    props.router.setRouteLeaveHook(props.route, routerWillLeave);
    return () => {
      // detaching event
      window.removeEventListener('beforeunload', beforeunload);
    };
  }, []);

  const routerWillLeave = nextLocation => {
    const hasEntUnsavedChangesData = dispatch(hasEntUnsavedChanges(ref));
    const hasUnsavedChanges = dispatch(dataCheck());
    if (
      (hasUnsavedChanges === true || hasEntUnsavedChangesData === true) &&
      navConfirmed === false
    ) {
      setRouterLeaveModal(true);
      setNextLocation(nextLocation.pathname);
      return false;
    }
    navConfirmed = false;
    return true;
  };

  const renderCADefaultView = () => {
    let activeNavFlag = false;
    const activeNavItem = navItems.find(item => item.active);
    if (activeNavItem) {
      activeNavFlag = true;
    }
    return activeNavFlag;
  };

  const confirmNavigation = () => {
    navConfirmed = true;
    setRouterLeaveModal(false);
    browserHistory.push(nextLocation);
    dispatch(setUnsavedChangeFlag(false));
  };

  const renderSupportView = () => {
    let renderView = '';
    if (navItems) {
      const activeNavItem = navItems.find(item => item.active);
      if (activeNavItem) {
        const activeNav =
          activeNavItem.children.length > 0
            ? activeNavItem.activeChild
            : activeNavItem.name;
        switch (activeNav) {
          case 'Details': {
            renderView = (
              <div className="mri-support-main ca-page-width">
                <CAAddNew ref={ref} />
              </div>
            );
            break;
          }
          case 'Contract View': {
            renderView = <div>Contract page</div>;
            break;
          }
          case 'Selections': {
            renderView = <div>Selections page</div>;
            break;
          }
          case 'Contact Information': {
            renderView = <div>Contact Information page</div>;
            break;
          }
          case 'Entitlement Creation': {
            renderView = (
              <div className="mri-support-main ent-page-width">
                <Entitlement
                  ref={ref}
                  editEntitlement={editEntitlement}
                  isTPPAccountSelected={isTPPAccountSelected}
                  selectedEntitlementId={selectedEntitlementId}
                  selectedContractId={selectedContractId}
                  accountId={accountId}
                  propCodes={propCodes}
                />
              </div>
            );
            break;
          }
          case 'Summary': {
            renderView = (
              <div className="mri-support-main ca-page-width">
                <CASummary />
              </div>
            );
            break;
          }
          case 'Search': {
            renderView = (
              <main className="mri-support-main ca-page-width">
                <ContractAdminView addNewBtn={addNewBtn} />
              </main>
            );
            break;
          }
          case 'Contact Directory': {
            renderView = <div>Contact Directory</div>;
            break;
          }
          default:
            renderView = <div>No Resources found.</div>;
        }
      }
      return renderView;
    }
  };
  const addNewBtn = () => {
    renderCADefaultView();
    dispatch(setAddNewFlag(true));
    dispatch(setEditedAccountData(resetForm()));
    dispatch(setSupportNav('Contract', 'Details'));
  };

  return (
    <div className="mri-support" data-test="contractAdminTest">
      {routerLeaveModal && (
        <RouterLeaveModal
          routerLeaveModal={routerLeaveModal}
          setRouterLeaveModal={setRouterLeaveModal}
          confirmNavigation={confirmNavigation}
        />
      )}
      {loginResponse.data.attributes.IS_CONTRACT_ADMIN === '1' && (
        <div className="mri-support-container">
          <div className="mri-support-left-nav">
            <h4 className="mri-support--header ca-left-menu-header">
              Contract Administration
            </h4>
            <nav className="mri-support-navigation">
              {navItems.length > 0 && (
                <LeftNav
                  navItems={navItems}
                  setSupportNav={updateSupportNav}
                  data-test="CALeftNavTest"
                />
              )}
            </nav>
          </div>
          {!addNewFlag &&
            !addNewEntitlement &&
            !isSummary &&
            !editEntitlement &&
            navItems.length > 0 &&
            renderCADefaultView() && (
              <main className="width100">{renderSupportView()}</main>
            )}
          {!addNewFlag &&
            !addNewEntitlement &&
            !isSummary &&
            !editEntitlement &&
            navItems.length > 0 &&
            !renderCADefaultView() && (
              <div className="mri-support-main">
                <ContractAdminView addNewBtn={addNewBtn} />
              </div>
            )}
          {addNewFlag && !addNewEntitlement && !isSummary && !editEntitlement && (
            <div className="mri-support-main">
              <CAAddNew ref={ref} />
            </div>
          )}
          {!addNewFlag && !isSummary && (addNewEntitlement || editEntitlement) && (
            <div className="mri-support-main">
              <Entitlement
                ref={ref}
                editEntitlement={editEntitlement}
                isTPPAccountSelected={isTPPAccountSelected}
                selectedEntitlementId={selectedEntitlementId}
                selectedContractId={selectedContractId}
                accountId={accountId}
                propCodes={propCodes}
              />
            </div>
          )}
          {!addNewFlag && !addNewEntitlement && !editEntitlement && isSummary && (
            <div className="mri-support-main">
              <CASummary />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(withRouter(ContractAdmin));
